import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Card, Space, Tag, Typography} from 'antd';
import GasPump from '../../assets/gas-pump.svg';
import UserGroup from '../../assets/user-group.svg';
import Car from '../../assets/car.svg';

import {roundToBookingIncrement} from '../../helpers/booking';

import "./DrawerCarDetailsCard.less";
import {DrawerCarDetailsCardProps} from '../../types/deploymentTypes';

const {Paragraph, Text} = Typography;

const DrawerCarDetailsCard = ({car, markerInfo, image, imageAltText, locationInfo, bookingMapInputState, isAvailable}: DrawerCarDetailsCardProps) => {
    const navigate = useNavigate();

    const onClick = () => {
        let {startedAt, endedAt, locationInput} = bookingMapInputState;

        // Start and End must be sent as strings and converted back to objs in VehicleInfo,
        // as dayjs objs have strange side effects in location.state on refresh.
        startedAt = startedAt ? roundToBookingIncrement(startedAt).toString() : null;
        endedAt = endedAt ? roundToBookingIncrement(endedAt).toString() : null;

        const stateObj = {
            carID: car.id,
            carName: car.name || 'N/A',
            locationInfo,
            markerInfo,
            locationInput,
            startedAt,
            endedAt,
        }
        navigate('/booking/map/create', {state: stateObj});
    }

    return (
        <Card
            className="booking-map-list-card"
            hoverable={true}
            onClick={onClick}
            cover={
                image &&
                <img alt={imageAltText} src={image} className="booking-map-list-card-img"/>
            }
        >
            <Card.Meta
                title={
                    <div>
                        {
                            !isAvailable && <p className="unavailable-text">UNAVAILABLE</p>
                        }
                        <Text>{car.name || 'N/A'}</Text>
                    </div>
                }
                description={
                    <>
                        <span>
                          <Paragraph className="car-card-description" ellipsis={{rows: 2}}>
                            {locationInfo.description || 'No current location.'}
                          </Paragraph>
                        </span>
                        <Space size={[5, 10]} wrap>
                            <Tag
                                className="tag-border-radius"
                                color="#E3EEF2"
                                icon={
                                    <div className="icon-wrapper">
                                        <img src={UserGroup} className="icon-black" alt="user-icon"/>
                                        <div className="icon-text">{car.seats}</div>
                                    </div>
                                }
                            />
                            <Tag
                                className="tag-border-radius"
                                color="#E3EEF2"
                                icon={
                                    <div className="icon-wrapper">
                                        <img src={GasPump} className="icon-black" alt="gas-pump-icon"/>
                                        <div className="icon-text">Hybrid</div>
                                    </div>
                                }
                            />
                            <Tag
                                className="tag-border-radius"
                                color="#E3EEF2"
                                icon={
                                    <div className="icon-wrapper">
                                        <img src={Car} className="icon-black" alt="car-icon"/>
                                        <div className="icon-text">{car.category}</div>
                                    </div>
                                }
                            />
                        </Space>
                    </>
                }
            />
        </Card>
    );
}

export default DrawerCarDetailsCard;